<iframe *ngIf="ctx" class="iframe" frameborder="0" [src]="ctx.Url | safeUrl"></iframe>
